// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared detail-page building blocks (mission / pipeline / project details) */

.detail-page {
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  width: 100%;
  max-width: 100%;
  overflow: visible;
  padding-bottom: 40px;
}

.detail-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.detail-page-head > div:first-child {
  flex: 1 1 280px;
  min-width: 0;
}

.detail-eyebrow {
  font-size: 13.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #8a9ba7;
  margin: 0 0 7px;
}

.detail-title {
  margin: 0;
  font-size: 27px;
  font-weight: 700;
  color: #0b1e2d;
  line-height: 1.2;
}

.detail-sub {
  margin: 8px 0 0;
  color: #5f7484;
  font-size: 14.5px;
  max-width: 62ch;
  line-height: 1.5;
}

.detail-head-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
  flex: none;
  padding-top: 22px;
}

.detail-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  height: 36px;
  padding: 0 14px;
  border-radius: 8px;
  border: none;
  background: #00146d;
  color: #fff;
  font-family: Lato, sans-serif;
  font-size: 15px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.14s;
}

.detail-btn:hover {
  background: #062a63;
}

.detail-btn--ghost {
  background: #fff;
  color: #0b1e2d;
  border: 1px solid #dfe7e8;
  box-shadow: none;
}

.detail-btn--ghost:hover {
  background: #f7fafa;
  border-color: #8a9ba7;
}

.detail-btn--sm {
  height: 36px;
  padding: 0 14px;
  font-size: 15px;
  border-radius: 8px;
}

.detail-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
  pointer-events: none;
}

.detail-btn svg {
  width: 15px;
  height: 15px;
  flex: none;
}

/* KPI grid */
.detail-kpi-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.detail-kpi-grid--2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.detail-kpi-grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.detail-kpi-grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.detail-kpi-grid--5 {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.detail-kpi-grid--6 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1100px) {
  .detail-kpi-grid,
  .detail-kpi-grid--3,
  .detail-kpi-grid--4,
  .detail-kpi-grid--5,
  .detail-kpi-grid--6 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .detail-kpi-grid--2 {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .detail-kpi-grid,
  .detail-kpi-grid--2,
  .detail-kpi-grid--3,
  .detail-kpi-grid--4,
  .detail-kpi-grid--5,
  .detail-kpi-grid--6 {
    grid-template-columns: 1fr;
  }
  .detail-title {
    font-size: 22px;
  }
}

.detail-kpi {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 118px;
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  padding: 16px 18px;
  overflow: hidden;
  box-sizing: border-box;
}

.detail-kpi .detail-eyebrow {
  margin: 0 0 10px;
  min-height: 2.7em;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.detail-kpi-value {
  font-size: 28px;
  font-weight: 600;
  line-height: 1.15;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
  min-height: 1.15em;
}

.detail-kpi-value--coral {
  color: #d14a3e;
}

.detail-kpi-value--sm {
  font-size: 22px;
}

.detail-kpi-desc {
  margin-top: auto;
  padding-top: 8px;
  min-height: 1.4em;
  font-size: 12.5px;
  color: #5f7484;
  line-height: 1.4;
}

.detail-kpi-desc.is-empty {
  visibility: hidden;
}

/* Dashboard composition under KPIs
   Both panels share one viewport-locked frame:
   Overview stays put; Description scrolls inside its card. */
.detail-dash-grid {
  display: grid;
  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);
  gap: 16px;
  align-items: stretch;
  margin-bottom: 16px;
  height: calc(100vh - 300px);
  min-height: 380px;
  max-height: 620px;
}

@media (max-width: 960px) {
  .detail-dash-grid {
    grid-template-columns: 1fr;
    height: auto;
    max-height: none;
    min-height: 0;
  }

  .detail-panel--sticky {
    height: auto;
  }

  .detail-panel--prose {
    height: min(55vh, 420px);
    max-height: min(55vh, 420px);
  }
}

.detail-panel {
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  overflow: hidden;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.detail-panel--sticky,
.detail-panel--prose {
  height: 100%;
}

.detail-panel-head {
  flex: none;
  padding: 14px 18px 12px;
  border-bottom: 1px solid #eaf0f0;
}

.detail-panel-title {
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #0b1e2d;
  letter-spacing: 0.01em;
}

.detail-panel-sub {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: #5f7484;
  line-height: 1.4;
}

.detail-panel-body {
  flex: 1 1 auto;
  min-height: 0;
  padding: 14px 18px 18px;
}

.detail-panel--sticky .detail-panel-body {
  overflow: auto;
}

.detail-panel--prose .detail-panel-body {
  overflow-y: auto;
  overscroll-behavior: contain;
  scrollbar-gutter: stable;
  padding-right: 14px;
}

.detail-panel--prose .detail-panel-body::-webkit-scrollbar,
.detail-panel--sticky .detail-panel-body::-webkit-scrollbar {
  width: 8px;
}

.detail-panel--prose .detail-panel-body::-webkit-scrollbar-thumb,
.detail-panel--sticky .detail-panel-body::-webkit-scrollbar-thumb {
  background: #cdd8d6;
  border-radius: 99px;
}

.detail-panel--prose .detail-panel-body::-webkit-scrollbar-track,
.detail-panel--sticky .detail-panel-body::-webkit-scrollbar-track {
  background: transparent;
}

.detail-panel .detail-info-grid,
.detail-panel .detail-info-stack {
  margin: 0;
}

.detail-panel .detail-acc-inner {
  padding: 0;
}

.detail-info-stack {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.detail-info-stack .detail-info-item {
  padding-bottom: 12px;
  border-bottom: 1px solid #eaf0f0;
}

.detail-info-stack .detail-info-item:last-child {
  padding-bottom: 0;
  border-bottom: none;
}

.detail-setup-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 26px;
  padding: 0 10px;
  border-radius: 99px;
  font-size: 12px;
  font-weight: 600;
  background: #faefda;
  color: #84540a;
}

.detail-setup-pill--ok {
  background: #e1f4f0;
  color: #076b5c;
}

.detail-prose {
  max-width: min(72ch, 100%);
  color: #0b1e2d;
}

.detail-panel--description {
  width: 100%;
  height: auto;
  margin-bottom: 16px;
}

.detail-panel--description .detail-prose {
  max-width: min(78ch, 100%);
}

.detail-panel--description .detail-prose-p {
  font-size: 15px;
  line-height: 1.7;
  color: #243746;
}

.detail-panel--description .detail-panel-body {
  overflow: visible;
}

.detail-desc {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
}

.detail-desc-body {
  width: 100%;
  position: relative;
}

.detail-desc-body.is-collapsed {
  max-height: 7.2em; /* ~4 lines at 1.7 line-height */
  overflow: hidden;
}

.detail-desc-body.is-collapsed::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 3.2em;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    #ffffff 88%
  );
}

.detail-desc-body.is-expanded {
  max-height: min(280px, 42vh);
  overflow: auto;
  overscroll-behavior: contain;
  padding-right: 6px;
  scrollbar-gutter: stable;
}

.detail-desc-body.is-expanded::-webkit-scrollbar {
  width: 8px;
}

.detail-desc-body.is-expanded::-webkit-scrollbar-thumb {
  background: #cdd8d6;
  border-radius: 99px;
}

.detail-desc-body.is-expanded::-webkit-scrollbar-track {
  background: transparent;
}

.detail-desc-toggle {
  appearance: none;
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 700;
  color: #076b5c;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.detail-desc-toggle:hover {
  color: #055447;
}

.detail-prose-p {
  margin: 0 0 14px;
  font-size: 14.5px;
  line-height: 1.65;
  color: #0b1e2d;
  font-weight: 450;
}

.detail-prose-p:last-child {
  margin-bottom: 0;
}

.detail-prose-list {
  margin: 0 0 14px;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.detail-prose-list:last-child {
  margin-bottom: 0;
}

.detail-prose-list li {
  position: relative;
  padding: 10px 12px 10px 14px;
  border-radius: 8px;
  background: #f7fafa;
  border: 1px solid #eaf0f0;
  font-size: 14px;
  line-height: 1.55;
  color: #0b1e2d;
}

.detail-prose-empty {
  margin: 0;
  font-size: 14px;
  color: #8a9ba7;
}

.detail-inline-link {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  font-size: 14px;
  font-weight: 500;
  color: #00146d;
  cursor: pointer;
  text-align: left;
  text-decoration: none;
}

.detail-inline-link:hover {
  color: #076b5c;
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* Accordion */
.detail-acc {
  border: 1px solid #dfe7e8;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);
  overflow: hidden;
  margin-bottom: 12px;
}

.detail-acc-head {
  width: 100% !important;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px 18px;
  text-align: left;
  background: #fff;
  border: none;
  cursor: pointer;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
  transition: background 0.14s;
}

.detail-acc-head:hover {
  background: #f7fafa;
}

.detail-acc.is-open .detail-acc-head {
  border-bottom: 1px solid #eaf0f0;
  background: #f7fafa;
}

.detail-acc-chev {
  width: 14px;
  height: 14px;
  flex: none;
  color: #8a9ba7;
  transition: transform 0.2s;
}

.detail-acc.is-open .detail-acc-chev {
  transform: rotate(90deg);
  color: #00146d;
}

.detail-acc-title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.detail-acc-count {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-size: 14px;
  color: #5f7484;
  background: #eaf0f0;
  padding: 2px 8px;
  border-radius: 99px;
}

.detail-acc-spacer {
  flex: 1 1;
}

.detail-acc-body {
  display: none;
}

.detail-acc.is-open .detail-acc-body {
  display: block;
}

.detail-acc-inner {
  padding: 16px 18px;
}

/* Info grid */
.detail-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.detail-info-item .detail-eyebrow {
  margin-bottom: 5px;
  font-size: 15px;
}

.detail-info-val {
  font-size: 16px;
  font-weight: 450;
  color: #0b1e2d;
  word-break: break-word;
}

.detail-info-val--mono {
  font-family: 'IBM Plex Mono', ui-monospace, monospace;
  font-variant-numeric: tabular-nums;
}

/* Section bar inside accordion */
.detail-sec-bar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 18px;
  border-bottom: 1px solid #eaf0f0;
  flex-wrap: wrap;
}

.detail-sec-bar h4 {
  margin: 0;
  font-size: 13.5px;
  font-weight: 600;
  margin-right: auto;
}

.detail-field-search {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 32px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  min-width: 180px;
  max-width: 230px;
  flex: 1 1;
}

.detail-field-search svg {
  width: 14px;
  height: 14px;
  color: #8a9ba7;
  flex: none;
}

.detail-field-search input {
  border: none;
  background: none;
  outline: none;
  width: 100%;
  font-size: 13px;
  font-family: Lato, sans-serif;
  color: #0b1e2d;
}

.detail-field-search input::placeholder {
  color: #8a9ba7;
}

/* Empty state */
.detail-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 28px 22px;
  text-align: center;
  min-height: 132px;
}

.detail-empty-ico {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: grid;
  place-items: center;
  background: #eaf0f0;
  color: #8a9ba7;
}

.detail-empty-ico svg {
  width: 16px;
  height: 16px;
}

.detail-empty-title {
  margin: 0;
  font-size: 13px;
  color: #0b1e2d;
  font-weight: 500;
}

.detail-empty-msg {
  margin: 0;
  font-size: 12.5px;
  color: #5f7484;
  max-width: 38ch;
  line-height: 1.5;
}

.detail-empty .detail-btn {
  margin-top: 4px;
}

/* Mini table inside detail sections */
.detail-table-shell {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.detail-table-wrap {
  overflow-x: auto;
  overflow-y: clip;
}

.detail-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
}

.detail-table thead th {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.13em;
  text-transform: uppercase;
  color: #8a9ba7;
  text-align: left;
  padding: 11px 16px;
  background: #f7fafa;
  border-bottom: 1px solid #dfe7e8;
  white-space: nowrap;
}

.detail-table thead th:first-child,
.detail-table tbody td:first-child {
  width: 100%;
  white-space: normal;
}

.detail-table thead th:not(:first-child),
.detail-table tbody td:not(:first-child) {
  width: 1%;
  white-space: nowrap;
}

.detail-table tbody td {
  padding: 13px 16px;
  border-bottom: 1px solid #eaf0f0;
  font-size: 16px;
  vertical-align: middle;
  color: #0b1e2d;
}

.detail-table tbody tr {
  cursor: pointer;
  transition: background 0.12s;
}

.detail-table tbody tr:hover {
  background: #f7fafa;
}

.detail-table tbody tr:last-child td {
  border-bottom: none;
}

.detail-table .incyia-name-link {
  font-size: 16px;
  color: #00146d;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.14s;
  display: inline;
  max-width: 100%;
}

.detail-table .incyia-name-link:hover,
.detail-table tbody tr:hover .incyia-name-link {
  color: #076b5c;
}

.detail-table .incyia-name-link:hover .incyia-desc,
.detail-table .incyia-name-link:hover .incyia-desc--primary,
.detail-table tbody tr:hover .incyia-name-link .incyia-desc,
.detail-table tbody tr:hover .incyia-name-link .incyia-desc--primary {
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-thickness: 1px;
}

.detail-table .incyia-name-link .incyia-desc,
.detail-table .incyia-name-link .incyia-desc--primary {
  cursor: pointer;
  color: inherit;
  text-decoration: none;
  width: fit-content;
  max-width: 100%;
}

.detail-table tbody td:first-child {
  cursor: pointer;
}

.detail-row-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
  opacity: 0.4;
  transition: opacity 0.14s;
}

.detail-table tbody tr:hover .detail-row-actions {
  opacity: 1;
}

.detail-icon-btn {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  display: grid;
  place-items: center;
  color: #5f7484;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.detail-icon-btn:hover {
  background: #eaf0f0;
  color: #0b1e2d;
}

.detail-loading {
  padding: 28px;
  text-align: center;
  color: #5f7484;
  font-size: 13.5px;
}

.detail-amount {
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 14px;
  color: #00146d;
  letter-spacing: 0.01em;
}

/* ——— Comments feed (task activities) ——— */
.detail-comments {
  display: flex;
  flex-direction: column;
  gap: 18px;
  width: 100%;
}

.detail-comment-composer {
  position: relative;
  background: linear-gradient(165deg, #ffffff 0%, #f7fafa 100%);
  border: 1px solid #dfe7e8;
  border-radius: 14px;
  padding: 18px 18px 14px;
  box-shadow: 0 1px 0 rgba(0, 20, 109, 0.04);
}

.detail-comment-composer-head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}

.detail-comment-composer-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #00146d;
}

.detail-comment-composer-hint {
  margin: 0;
  font-size: 12px;
  color: #8a9ba7;
}

.detail-comment-textarea {
  width: 100%;
  min-height: 88px;
  resize: vertical;
  border: 1px solid #dfe7e8;
  border-radius: 10px;
  padding: 12px 14px;
  font-family: Lato, sans-serif;
  font-size: 14px;
  line-height: 1.45;
  color: #0b1e2d;
  background: #fff;
  outline: none;
  transition: border-color 0.14s, box-shadow 0.14s;
  box-sizing: border-box;
}

.detail-comment-textarea:focus {
  border-color: #0d9b87;
  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.15);
}

.detail-comment-textarea::placeholder {
  color: #8a9ba7;
}

.detail-comment-composer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
}

.detail-comment-feed {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-comment-feed-meta {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8a9ba7;
  margin: 4px 0 0;
}

.detail-comment-card {
  display: grid;
  grid-template-columns: 40px 1fr;
  gap: 12px;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid #eaf0f0;
  border-radius: 12px;
  border-left: 3px solid #0d9b87;
  transition: border-color 0.14s, box-shadow 0.14s;
}

.detail-comment-card:hover {
  border-color: #dfe7e8;
  box-shadow: 0 4px 16px rgba(6, 21, 36, 0.05);
}

.detail-comment-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-family: Lato, sans-serif;
  font-weight: 700;
  font-size: 15px;
  color: #076b5c;
  background: linear-gradient(145deg, #e1f4f0, #c8ebe4);
  flex-shrink: 0;
}

.detail-comment-body {
  min-width: 0;
}

.detail-comment-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}

.detail-comment-author {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 13.5px;
  font-weight: 700;
  color: #0b1e2d;
}

.detail-comment-time {
  margin: 2px 0 0;
  font-size: 12px;
  color: #8a9ba7;
}

.detail-comment-text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
  color: #0b1e2d;
  white-space: pre-wrap;
  word-break: break-word;
}

.detail-comment-edit-actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 10px;
}

.detail-comment-empty {
  padding: 28px 16px;
  text-align: center;
  color: #5f7484;
  font-size: 13.5px;
  background: #f7fafa;
  border-radius: 12px;
  border: 1px dashed #dfe7e8;
}

/* ——— RASCI matrix board (5-column) ——— */
.rasci-board {
  width: 100%;
}

.rasci-board-head {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

.rasci-board-kicker {
  margin: 0 0 2px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: #0d9b87;
}

.rasci-board-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #00146d;
}

.rasci-columns {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 12px;
  width: 100%;
  align-items: stretch;
}

@media (max-width: 1100px) {
  .rasci-columns {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .rasci-columns {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 420px) {
  .rasci-columns {
    grid-template-columns: 1fr;
  }
}

.rasci-col {
  display: flex;
  flex-direction: column;
  min-height: 168px;
  background: #fff;
  border: 1px solid #eaf0f0;
  border-radius: 14px;
  overflow: hidden;
  border-top: 3px solid var(--rasci-accent, #0d9b87);
  transition: box-shadow 0.16s, border-color 0.16s, transform 0.16s;
}

.rasci-col:hover {
  border-color: #dfe7e8;
  box-shadow: 0 8px 24px rgba(6, 21, 36, 0.06);
  transform: translateY(-1px);
}

.rasci-col-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 14px 10px;
  background: linear-gradient(180deg, #f7fafa 0%, #fff 100%);
}

.rasci-letter {
  width: 32px;
  height: 32px;
  border-radius: 9px;
  display: grid;
  place-items: center;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 800;
  letter-spacing: 0.02em;
  flex-shrink: 0;
}

.rasci-col-label {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.rasci-col-name {
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #0b1e2d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rasci-col-count {
  font-size: 11.5px;
  color: #8a9ba7;
  font-weight: 500;
}

.rasci-col-body {
  flex: 1 1;
  padding: 4px 12px 14px;
  display: flex;
  flex-direction: column;
}

.rasci-people {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.rasci-person {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 8px;
  border-radius: 9px;
  background: #f7fafa;
  border: 1px solid transparent;
  min-width: 0;
}

.rasci-person:hover {
  border-color: #eaf0f0;
  background: #fff;
}

.rasci-person-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  font-size: 11px;
  font-weight: 800;
  flex-shrink: 0;
}

.rasci-person-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #0b1e2d;
  text-transform: capitalize;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rasci-unassigned {
  margin-top: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 10px;
  border-radius: 9px;
  border: 1px dashed #dfe7e8;
  background: #fafcfc;
  color: #8a9ba7;
  font-size: 12.5px;
  font-weight: 500;
}

.rasci-unassigned-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #c5d4d6;
  flex-shrink: 0;
}

/* ——— Support document ——— */
.support-panel {
  width: 100%;
}

.support-file-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  padding: 16px 18px;
  background: linear-gradient(165deg, #ffffff 0%, #f7fafa 100%);
  border: 1px solid #dfe7e8;
  border-radius: 14px;
  border-left: 3px solid #0d9b87;
}

.support-file-main {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
  flex: 1 1;
}

.support-file-ico {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: #e1f4f0;
  color: #076b5c;
  flex-shrink: 0;
}

.support-file-meta {
  min-width: 0;
}

.support-file-name {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 14.5px;
  font-weight: 700;
  color: #00146d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.support-file-hint {
  margin: 3px 0 0;
  font-size: 12.5px;
  color: #8a9ba7;
}

.support-file-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.support-dropzone {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
  padding: 36px 24px;
  border-radius: 14px;
  border: 1.5px dashed #c5d4d6;
  background: #f7fafa;
  transition: border-color 0.14s, background 0.14s;
}

.support-dropzone.is-drag {
  border-color: #0d9b87;
  background: #e1f4f0;
}

.support-drop-ico {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: grid;
  place-items: center;
  background: #fff;
  color: #0d9b87;
  border: 1px solid #dfe7e8;
  margin-bottom: 4px;
}

.support-drop-title {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 15px;
  font-weight: 700;
  color: #00146d;
}

.support-drop-msg {
  margin: 0 0 10px;
  max-width: 420px;
  font-size: 13.5px;
  line-height: 1.45;
  color: #5f7484;
}

.support-drop-error {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: #d14a3e;
}

/* ——— Shared detail modal shell ——— */
.incyia-modal-paper {
  border-radius: 14px !important;
  overflow: hidden;
  box-shadow: 0 30px 80px -24px rgba(0, 0, 0, 0.45) !important;
  font-family: Lato, sans-serif;
}

.incyia-modal-head {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 22px 0;
}

.incyia-modal-head h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #00146d;
  font-family: Lato, sans-serif;
}

.incyia-modal-head p {
  margin: 4px 0 0;
  font-size: 12.5px;
  color: #5f7484;
  line-height: 1.4;
}

.incyia-combo {
  display: flex;
  flex-wrap: wrap;
  gap: 14px 22px;
  margin-top: 12px;
}

.incyia-combo-item {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.incyia-combo-k {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #8a9ba7;
}

.incyia-combo-v {
  font-size: 14px;
  font-weight: 600;
  color: #0b1e2d;
  line-height: 1.35;
}

.incyia-combo-banner {
  margin: 0 0 16px;
  padding: 14px 16px;
  border: 1px solid #d7e4ea;
  border-left: 3px solid #0d9b87;
  border-radius: 10px;
  background: #f4fbf9;
}

.incyia-combo-banner h3 {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #00146d;
}

.incyia-combo-banner > p {
  margin: 4px 0 0;
  font-size: 14px;
  line-height: 1.45;
  color: #5f7484;
}

.incyia-fix-dialog.incyia-modal-paper {
  max-width: 560px;
}

.incyia-fix-dialog .incyia-modal-head {
  padding: 24px 24px 0;
}

.incyia-fix-dialog .incyia-modal-head h3 {
  font-size: 20px;
  line-height: 1.3;
}

.incyia-fix-dialog .incyia-modal-head p {
  margin-top: 8px;
  font-size: 16px;
  line-height: 1.5;
  color: #3d5160;
}

.incyia-fix-dialog .incyia-modal-body {
  padding: 16px 24px 8px;
}

.incyia-fix-dialog .incyia-combo {
  flex-direction: column;
  gap: 12px;
  margin: 0;
  padding: 14px 16px;
  border-radius: 10px;
  background: #f4fbf9;
  border: 1px solid #d7e4ea;
}

.incyia-fix-dialog .incyia-combo-k {
  font-size: 13px;
  letter-spacing: 0.04em;
}

.incyia-fix-dialog .incyia-combo-v {
  font-size: 16px;
  line-height: 1.4;
}

.incyia-fix-dialog .incyia-modal-foot {
  padding: 16px 24px;
}

.incyia-fix-dialog .detail-btn {
  height: 40px;
  padding: 0 16px;
  font-size: 16px;
}

.incyia-modal-x {
  margin-left: auto;
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: grid;
  place-items: center;
  color: #8a9ba7;
  background: none;
  border: none;
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
}

.incyia-modal-x:hover {
  background: #eaf0f0;
  color: #0b1e2d;
}

.incyia-status-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 0;
  padding: 12px 18px;
}

.incyia-modal-body {
  padding: 18px 22px;
}

.incyia-modal-foot {
  padding: 14px 22px;
  background: #f7fafa;
  border-top: 1px solid #dfe7e8;
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.incyia-confirm-details {
  margin: 0;
  padding: 12px 14px;
  border-radius: 12px;
  background: #f7f9fd;
  border: 1px solid #eaeff7;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.incyia-confirm-detail {
  display: grid;
  grid-template-columns: 100px 1fr;
  gap: 10px;
  align-items: start;
}

.incyia-confirm-detail dt {
  margin: 0;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8b99b4;
  padding-top: 2px;
}

.incyia-confirm-detail dd {
  margin: 0;
  font-size: 13.5px;
  font-weight: 600;
  color: #0b1e2d;
  line-height: 1.35;
  word-break: break-word;
}

.detail-icon-btn--danger {
  color: #8a9ba7;
}

.detail-icon-btn--danger:hover {
  background: #fae6e3;
  color: #d14a3e;
}

.incyia-modal-icon {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
  background: #e2f7f2;
  color: #076b5c;
}

.incyia-modal-icon--warn {
  background: #fff4e5;
  color: #b86e00;
}

.incyia-modal-icon--danger {
  background: #fae6e3;
  color: #d14a3e;
}

.incyia-modal-countdown {
  margin: 4px 0 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  padding: 16px;
  border-radius: 12px;
  background: #f7f9fd;
  border: 1px solid #eaeff7;
}

.incyia-modal-countdown-value {
  font-size: 28px;
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #00146d;
  font-variant-numeric: tabular-nums;
  font-family: Lato, sans-serif;
}

.incyia-modal-countdown-label {
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #8b99b4;
}

.detail-btn--danger {
  background: #d14a3e !important;
  color: #fff !important;
  box-shadow: 0 1px 2px rgba(209, 74, 62, 0.35);
}

.detail-btn--danger:hover:not(:disabled) {
  background: #b83f35 !important;
}

/* RASCI assign / edit modal */
.rasci-edit-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rasci-edit-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 220px;
  padding: 24px;
  text-align: center;
}

.rasci-edit-loading p {
  margin: 0;
  font-size: 13.5px;
  color: #5f7484;
}

.rasci-edit-spinner {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2.5px solid #e1f4f0;
  border-top-color: #0d9b87;
  animation: rasci-spin 0.7s linear infinite;
}

@keyframes rasci-spin {
  to {
    transform: rotate(360deg);
  }
}

.rasci-edit-row {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 12px;
  background: #f7fafa;
  border: 1px solid #eaf0f0;
  border-radius: 12px;
}

@media (max-width: 560px) {
  .rasci-edit-row {
    grid-template-columns: 1fr;
    align-items: start;
  }
}

.rasci-edit-role {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 7px 10px;
  border-radius: 8px;
  font-size: 12.5px;
  font-weight: 700;
  width: fit-content;
  max-width: 100%;
}

.rasci-edit-field {
  min-width: 0;
  width: 100%;
}

.rasci-edit-select {
  width: 100%;
}

.rasci-edit-select .MuiOutlinedInput-root {
  background: #fff;
  border-radius: 8px;
  font-family: Lato, sans-serif;
  font-size: 13px;
  min-height: 40px;
}

.rasci-edit-select .MuiSelect-select {
  padding-top: 8px;
  padding-bottom: 8px;
}

.rasci-edit-select .MuiOutlinedInput-notchedOutline {
  border-color: #dfe7e8;
}

.rasci-edit-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {
  border-color: #8a9ba7;
}

.rasci-edit-select .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #0d9b87 !important;
  border-width: 1.5px !important;
}

.rasci-select-placeholder {
  color: #8a9ba7;
  font-size: 13px;
  font-family: Lato, sans-serif;
}

.rasci-edit-chip {
  border-radius: 999px !important;
  background: #e1f4f0 !important;
  color: #076b5c !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  height: 26px !important;
  max-width: 160px;
}

.rasci-edit-chip .MuiChip-label {
  overflow: hidden;
  text-overflow: ellipsis;
}

.rasci-select-menu {
  border-radius: 10px !important;
  border: 1px solid #dfe7e8 !important;
  box-shadow: 0 16px 40px rgba(6, 21, 36, 0.14) !important;
  overflow: hidden;
}

.rasci-select-menu-list {
  padding: 6px !important;
  font-family: Lato, sans-serif;
}

.rasci-select-option {
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  gap: 10px !important;
  margin: 2px 0 !important;
  padding: 8px 10px !important;
  border-radius: 8px !important;
  font-family: Lato, sans-serif !important;
  font-size: 13px !important;
  color: #0b1e2d !important;
  min-width: 0 !important;
}

.rasci-select-option:hover,
.rasci-select-option.Mui-focused {
  background: #f7fafa !important;
}

.rasci-select-option.Mui-selected {
  background: #e1f4f0 !important;
  color: #076b5c !important;
}

.rasci-select-option.Mui-selected:hover {
  background: #d2efe8 !important;
}

.rasci-select-option-name {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: 600;
}

.rasci-edit-menu-role {
  flex-shrink: 0;
  background: #eaf0f0;
  color: #5f7484;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  max-width: 72px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Document viewer */
.doc-viewer-shell {
  display: flex;
  flex-direction: column;
  height: min(78vh, 720px);
  background: #0b1e2d;
}

.doc-viewer-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding: 12px 16px;
  background: linear-gradient(180deg, #0f2740 0%, #0b1e2d 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.doc-viewer-file {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.doc-viewer-file-ico {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: grid;
  place-items: center;
  background: rgba(13, 155, 135, 0.18);
  color: #5ee0cb;
  flex-shrink: 0;
}

.doc-viewer-file-name {
  margin: 0;
  font-family: Lato, sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #fff;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: min(420px, 55vw);
}

.doc-viewer-file-sub {
  margin: 2px 0 0;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.55);
}

.doc-viewer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.doc-viewer-frame-wrap {
  flex: 1 1;
  min-height: 0;
  background: #525659;
  position: relative;
}

.doc-viewer-frame-wrap iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}

.doc-viewer-fallback {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 32px;
  text-align: center;
  background: #f7fafa;
  color: #5f7484;
}

.doc-viewer-fallback p {
  margin: 0;
  max-width: 360px;
  font-size: 13.5px;
  line-height: 1.45;
}

.doc-viewer-actions .detail-btn--ghost {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  border-color: rgba(255, 255, 255, 0.16);
}

.doc-viewer-actions .detail-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.14);
  border-color: rgba(255, 255, 255, 0.28);
}

.doc-viewer-actions .detail-btn:not(.detail-btn--ghost) {
  background: #0d9b87;
}

.doc-viewer-actions .detail-btn:not(.detail-btn--ghost):hover {
  background: #076b5c;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/detail/detail.css"],"names":[],"mappings":"AAAA,8EAA8E;;AAE9E;EACE,6BAA6B;EAC7B,cAAc;EACd,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;AACZ;;AAEA,aAAa;AACb;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE;;;;;IAKE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;;;;;IAME,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;6DAE6D;AAC7D;EACE,aAAa;EACb,0DAA0D;EAC1D,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,2CAA2C;EAC3C,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB,EAAE,gCAAgC;EACnD,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,aAAa;EACb,oBAAoB;EACpB;;;;GAIC;AACH;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,4BAA4B;EAC5B,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;EACT,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,6BAA6B;EAC7B,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;EACrD,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,qDAAqD;EACrD,kCAAkC;AACpC;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,eAAe;EACf,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,uBAAuB;EACvB,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;;;EAIE,0BAA0B;EAC1B,0BAA0B;EAC1B,8BAA8B;AAChC;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;EAC9B,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,0CAA0C;AAC1C;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,kDAAkD;EAClD,iEAAiE;AACnE;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,uBAAuB;EACvB,0DAA0D;AAC5D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,yBAAyB;EACzB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;EAC5B,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,4DAA4D;EAC5D,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kCAAkC;EAClC,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,8BAA8B;AAChC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,wDAAwD;EACxD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;EAC5B,6BAA6B;EAC7B,wCAAwC;EACxC,0BAA0B;EAC1B,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,kBAAkB;EAClB,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Shared detail-page building blocks (mission / pipeline / project details) */\n\n.detail-page {\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  width: 100%;\n  max-width: 100%;\n  overflow: visible;\n  padding-bottom: 40px;\n}\n\n.detail-page-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 20px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.detail-page-head > div:first-child {\n  flex: 1 1 280px;\n  min-width: 0;\n}\n\n.detail-eyebrow {\n  font-size: 13.5px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n  margin: 0 0 7px;\n}\n\n.detail-title {\n  margin: 0;\n  font-size: 27px;\n  font-weight: 700;\n  color: #0b1e2d;\n  line-height: 1.2;\n}\n\n.detail-sub {\n  margin: 8px 0 0;\n  color: #5f7484;\n  font-size: 14.5px;\n  max-width: 62ch;\n  line-height: 1.5;\n}\n\n.detail-head-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n  flex: none;\n  padding-top: 22px;\n}\n\n.detail-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  height: 36px;\n  padding: 0 14px;\n  border-radius: 8px;\n  border: none;\n  background: #00146d;\n  color: #fff;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.14s;\n}\n\n.detail-btn:hover {\n  background: #062a63;\n}\n\n.detail-btn--ghost {\n  background: #fff;\n  color: #0b1e2d;\n  border: 1px solid #dfe7e8;\n  box-shadow: none;\n}\n\n.detail-btn--ghost:hover {\n  background: #f7fafa;\n  border-color: #8a9ba7;\n}\n\n.detail-btn--sm {\n  height: 36px;\n  padding: 0 14px;\n  font-size: 15px;\n  border-radius: 8px;\n}\n\n.detail-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.detail-btn svg {\n  width: 15px;\n  height: 15px;\n  flex: none;\n}\n\n/* KPI grid */\n.detail-kpi-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.detail-kpi-grid--2 {\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.detail-kpi-grid--3 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.detail-kpi-grid--4 {\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.detail-kpi-grid--5 {\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.detail-kpi-grid--6 {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n@media (max-width: 1100px) {\n  .detail-kpi-grid,\n  .detail-kpi-grid--3,\n  .detail-kpi-grid--4,\n  .detail-kpi-grid--5,\n  .detail-kpi-grid--6 {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .detail-kpi-grid--2 {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 560px) {\n  .detail-kpi-grid,\n  .detail-kpi-grid--2,\n  .detail-kpi-grid--3,\n  .detail-kpi-grid--4,\n  .detail-kpi-grid--5,\n  .detail-kpi-grid--6 {\n    grid-template-columns: 1fr;\n  }\n  .detail-title {\n    font-size: 22px;\n  }\n}\n\n.detail-kpi {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 118px;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  padding: 16px 18px;\n  overflow: hidden;\n  box-sizing: border-box;\n}\n\n.detail-kpi .detail-eyebrow {\n  margin: 0 0 10px;\n  min-height: 2.7em;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.detail-kpi-value {\n  font-size: 28px;\n  font-weight: 600;\n  line-height: 1.15;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n  min-height: 1.15em;\n}\n\n.detail-kpi-value--coral {\n  color: #d14a3e;\n}\n\n.detail-kpi-value--sm {\n  font-size: 22px;\n}\n\n.detail-kpi-desc {\n  margin-top: auto;\n  padding-top: 8px;\n  min-height: 1.4em;\n  font-size: 12.5px;\n  color: #5f7484;\n  line-height: 1.4;\n}\n\n.detail-kpi-desc.is-empty {\n  visibility: hidden;\n}\n\n/* Dashboard composition under KPIs\n   Both panels share one viewport-locked frame:\n   Overview stays put; Description scrolls inside its card. */\n.detail-dash-grid {\n  display: grid;\n  grid-template-columns: minmax(260px, 320px) minmax(0, 1fr);\n  gap: 16px;\n  align-items: stretch;\n  margin-bottom: 16px;\n  height: calc(100vh - 300px);\n  min-height: 380px;\n  max-height: 620px;\n}\n\n@media (max-width: 960px) {\n  .detail-dash-grid {\n    grid-template-columns: 1fr;\n    height: auto;\n    max-height: none;\n    min-height: 0;\n  }\n\n  .detail-panel--sticky {\n    height: auto;\n  }\n\n  .detail-panel--prose {\n    height: min(55vh, 420px);\n    max-height: min(55vh, 420px);\n  }\n}\n\n.detail-panel {\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  overflow: hidden;\n  min-width: 0;\n  min-height: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.detail-panel--sticky,\n.detail-panel--prose {\n  height: 100%;\n}\n\n.detail-panel-head {\n  flex: none;\n  padding: 14px 18px 12px;\n  border-bottom: 1px solid #eaf0f0;\n}\n\n.detail-panel-title {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 700;\n  color: #0b1e2d;\n  letter-spacing: 0.01em;\n}\n\n.detail-panel-sub {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  color: #5f7484;\n  line-height: 1.4;\n}\n\n.detail-panel-body {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding: 14px 18px 18px;\n}\n\n.detail-panel--sticky .detail-panel-body {\n  overflow: auto;\n}\n\n.detail-panel--prose .detail-panel-body {\n  overflow-y: auto;\n  overscroll-behavior: contain;\n  scrollbar-gutter: stable;\n  padding-right: 14px;\n}\n\n.detail-panel--prose .detail-panel-body::-webkit-scrollbar,\n.detail-panel--sticky .detail-panel-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.detail-panel--prose .detail-panel-body::-webkit-scrollbar-thumb,\n.detail-panel--sticky .detail-panel-body::-webkit-scrollbar-thumb {\n  background: #cdd8d6;\n  border-radius: 99px;\n}\n\n.detail-panel--prose .detail-panel-body::-webkit-scrollbar-track,\n.detail-panel--sticky .detail-panel-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.detail-panel .detail-info-grid,\n.detail-panel .detail-info-stack {\n  margin: 0;\n}\n\n.detail-panel .detail-acc-inner {\n  padding: 0;\n}\n\n.detail-info-stack {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.detail-info-stack .detail-info-item {\n  padding-bottom: 12px;\n  border-bottom: 1px solid #eaf0f0;\n}\n\n.detail-info-stack .detail-info-item:last-child {\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n.detail-setup-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  height: 26px;\n  padding: 0 10px;\n  border-radius: 99px;\n  font-size: 12px;\n  font-weight: 600;\n  background: #faefda;\n  color: #84540a;\n}\n\n.detail-setup-pill--ok {\n  background: #e1f4f0;\n  color: #076b5c;\n}\n\n.detail-prose {\n  max-width: min(72ch, 100%);\n  color: #0b1e2d;\n}\n\n.detail-panel--description {\n  width: 100%;\n  height: auto;\n  margin-bottom: 16px;\n}\n\n.detail-panel--description .detail-prose {\n  max-width: min(78ch, 100%);\n}\n\n.detail-panel--description .detail-prose-p {\n  font-size: 15px;\n  line-height: 1.7;\n  color: #243746;\n}\n\n.detail-panel--description .detail-panel-body {\n  overflow: visible;\n}\n\n.detail-desc {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  align-items: flex-start;\n}\n\n.detail-desc-body {\n  width: 100%;\n  position: relative;\n}\n\n.detail-desc-body.is-collapsed {\n  max-height: 7.2em; /* ~4 lines at 1.7 line-height */\n  overflow: hidden;\n}\n\n.detail-desc-body.is-collapsed::after {\n  content: '';\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 3.2em;\n  pointer-events: none;\n  background: linear-gradient(\n    180deg,\n    rgba(255, 255, 255, 0) 0%,\n    #ffffff 88%\n  );\n}\n\n.detail-desc-body.is-expanded {\n  max-height: min(280px, 42vh);\n  overflow: auto;\n  overscroll-behavior: contain;\n  padding-right: 6px;\n  scrollbar-gutter: stable;\n}\n\n.detail-desc-body.is-expanded::-webkit-scrollbar {\n  width: 8px;\n}\n\n.detail-desc-body.is-expanded::-webkit-scrollbar-thumb {\n  background: #cdd8d6;\n  border-radius: 99px;\n}\n\n.detail-desc-body.is-expanded::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.detail-desc-toggle {\n  appearance: none;\n  border: none;\n  background: none;\n  padding: 0;\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #076b5c;\n  cursor: pointer;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n.detail-desc-toggle:hover {\n  color: #055447;\n}\n\n.detail-prose-p {\n  margin: 0 0 14px;\n  font-size: 14.5px;\n  line-height: 1.65;\n  color: #0b1e2d;\n  font-weight: 450;\n}\n\n.detail-prose-p:last-child {\n  margin-bottom: 0;\n}\n\n.detail-prose-list {\n  margin: 0 0 14px;\n  padding: 0;\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.detail-prose-list:last-child {\n  margin-bottom: 0;\n}\n\n.detail-prose-list li {\n  position: relative;\n  padding: 10px 12px 10px 14px;\n  border-radius: 8px;\n  background: #f7fafa;\n  border: 1px solid #eaf0f0;\n  font-size: 14px;\n  line-height: 1.55;\n  color: #0b1e2d;\n}\n\n.detail-prose-empty {\n  margin: 0;\n  font-size: 14px;\n  color: #8a9ba7;\n}\n\n.detail-inline-link {\n  background: none;\n  border: none;\n  padding: 0;\n  margin: 0;\n  font: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  color: #00146d;\n  cursor: pointer;\n  text-align: left;\n  text-decoration: none;\n}\n\n.detail-inline-link:hover {\n  color: #076b5c;\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n/* Accordion */\n.detail-acc {\n  border: 1px solid #dfe7e8;\n  border-radius: 12px;\n  background: #fff;\n  box-shadow: 0 1px 2px rgba(6, 21, 36, 0.04);\n  overflow: hidden;\n  margin-bottom: 12px;\n}\n\n.detail-acc-head {\n  width: 100% !important;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  gap: 11px;\n  padding: 13px 18px;\n  text-align: left;\n  background: #fff;\n  border: none;\n  cursor: pointer;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n  transition: background 0.14s;\n}\n\n.detail-acc-head:hover {\n  background: #f7fafa;\n}\n\n.detail-acc.is-open .detail-acc-head {\n  border-bottom: 1px solid #eaf0f0;\n  background: #f7fafa;\n}\n\n.detail-acc-chev {\n  width: 14px;\n  height: 14px;\n  flex: none;\n  color: #8a9ba7;\n  transition: transform 0.2s;\n}\n\n.detail-acc.is-open .detail-acc-chev {\n  transform: rotate(90deg);\n  color: #00146d;\n}\n\n.detail-acc-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.detail-acc-count {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-size: 14px;\n  color: #5f7484;\n  background: #eaf0f0;\n  padding: 2px 8px;\n  border-radius: 99px;\n}\n\n.detail-acc-spacer {\n  flex: 1;\n}\n\n.detail-acc-body {\n  display: none;\n}\n\n.detail-acc.is-open .detail-acc-body {\n  display: block;\n}\n\n.detail-acc-inner {\n  padding: 16px 18px;\n}\n\n/* Info grid */\n.detail-info-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 16px;\n}\n\n.detail-info-item .detail-eyebrow {\n  margin-bottom: 5px;\n  font-size: 15px;\n}\n\n.detail-info-val {\n  font-size: 16px;\n  font-weight: 450;\n  color: #0b1e2d;\n  word-break: break-word;\n}\n\n.detail-info-val--mono {\n  font-family: 'IBM Plex Mono', ui-monospace, monospace;\n  font-variant-numeric: tabular-nums;\n}\n\n/* Section bar inside accordion */\n.detail-sec-bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 12px 18px;\n  border-bottom: 1px solid #eaf0f0;\n  flex-wrap: wrap;\n}\n\n.detail-sec-bar h4 {\n  margin: 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  margin-right: auto;\n}\n\n.detail-field-search {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  height: 32px;\n  padding: 0 10px;\n  background: #fff;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  min-width: 180px;\n  max-width: 230px;\n  flex: 1;\n}\n\n.detail-field-search svg {\n  width: 14px;\n  height: 14px;\n  color: #8a9ba7;\n  flex: none;\n}\n\n.detail-field-search input {\n  border: none;\n  background: none;\n  outline: none;\n  width: 100%;\n  font-size: 13px;\n  font-family: Lato, sans-serif;\n  color: #0b1e2d;\n}\n\n.detail-field-search input::placeholder {\n  color: #8a9ba7;\n}\n\n/* Empty state */\n.detail-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 28px 22px;\n  text-align: center;\n  min-height: 132px;\n}\n\n.detail-empty-ico {\n  width: 34px;\n  height: 34px;\n  border-radius: 9px;\n  display: grid;\n  place-items: center;\n  background: #eaf0f0;\n  color: #8a9ba7;\n}\n\n.detail-empty-ico svg {\n  width: 16px;\n  height: 16px;\n}\n\n.detail-empty-title {\n  margin: 0;\n  font-size: 13px;\n  color: #0b1e2d;\n  font-weight: 500;\n}\n\n.detail-empty-msg {\n  margin: 0;\n  font-size: 12.5px;\n  color: #5f7484;\n  max-width: 38ch;\n  line-height: 1.5;\n}\n\n.detail-empty .detail-btn {\n  margin-top: 4px;\n}\n\n/* Mini table inside detail sections */\n.detail-table-shell {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n}\n\n.detail-table-wrap {\n  overflow-x: auto;\n  overflow-y: clip;\n}\n\n.detail-table {\n  width: 100%;\n  border-collapse: collapse;\n  table-layout: auto;\n}\n\n.detail-table thead th {\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0.13em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n  text-align: left;\n  padding: 11px 16px;\n  background: #f7fafa;\n  border-bottom: 1px solid #dfe7e8;\n  white-space: nowrap;\n}\n\n.detail-table thead th:first-child,\n.detail-table tbody td:first-child {\n  width: 100%;\n  white-space: normal;\n}\n\n.detail-table thead th:not(:first-child),\n.detail-table tbody td:not(:first-child) {\n  width: 1%;\n  white-space: nowrap;\n}\n\n.detail-table tbody td {\n  padding: 13px 16px;\n  border-bottom: 1px solid #eaf0f0;\n  font-size: 16px;\n  vertical-align: middle;\n  color: #0b1e2d;\n}\n\n.detail-table tbody tr {\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.detail-table tbody tr:hover {\n  background: #f7fafa;\n}\n\n.detail-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.detail-table .incyia-name-link {\n  font-size: 16px;\n  color: #00146d;\n  text-decoration: none;\n  cursor: pointer;\n  transition: color 0.14s;\n  display: inline;\n  max-width: 100%;\n}\n\n.detail-table .incyia-name-link:hover,\n.detail-table tbody tr:hover .incyia-name-link {\n  color: #076b5c;\n}\n\n.detail-table .incyia-name-link:hover .incyia-desc,\n.detail-table .incyia-name-link:hover .incyia-desc--primary,\n.detail-table tbody tr:hover .incyia-name-link .incyia-desc,\n.detail-table tbody tr:hover .incyia-name-link .incyia-desc--primary {\n  text-decoration: underline;\n  text-underline-offset: 3px;\n  text-decoration-thickness: 1px;\n}\n\n.detail-table .incyia-name-link .incyia-desc,\n.detail-table .incyia-name-link .incyia-desc--primary {\n  cursor: pointer;\n  color: inherit;\n  text-decoration: none;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.detail-table tbody td:first-child {\n  cursor: pointer;\n}\n\n.detail-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: flex-end;\n  opacity: 0.4;\n  transition: opacity 0.14s;\n}\n\n.detail-table tbody tr:hover .detail-row-actions {\n  opacity: 1;\n}\n\n.detail-icon-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 6px;\n  display: grid;\n  place-items: center;\n  color: #5f7484;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.detail-icon-btn:hover {\n  background: #eaf0f0;\n  color: #0b1e2d;\n}\n\n.detail-loading {\n  padding: 28px;\n  text-align: center;\n  color: #5f7484;\n  font-size: 13.5px;\n}\n\n.detail-amount {\n  font-family: Lato, sans-serif;\n  font-weight: 700;\n  font-size: 14px;\n  color: #00146d;\n  letter-spacing: 0.01em;\n}\n\n/* ——— Comments feed (task activities) ——— */\n.detail-comments {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  width: 100%;\n}\n\n.detail-comment-composer {\n  position: relative;\n  background: linear-gradient(165deg, #ffffff 0%, #f7fafa 100%);\n  border: 1px solid #dfe7e8;\n  border-radius: 14px;\n  padding: 18px 18px 14px;\n  box-shadow: 0 1px 0 rgba(0, 20, 109, 0.04);\n}\n\n.detail-comment-composer-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 12px;\n}\n\n.detail-comment-composer-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.detail-comment-composer-hint {\n  margin: 0;\n  font-size: 12px;\n  color: #8a9ba7;\n}\n\n.detail-comment-textarea {\n  width: 100%;\n  min-height: 88px;\n  resize: vertical;\n  border: 1px solid #dfe7e8;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #0b1e2d;\n  background: #fff;\n  outline: none;\n  transition: border-color 0.14s, box-shadow 0.14s;\n  box-sizing: border-box;\n}\n\n.detail-comment-textarea:focus {\n  border-color: #0d9b87;\n  box-shadow: 0 0 0 3px rgba(13, 155, 135, 0.15);\n}\n\n.detail-comment-textarea::placeholder {\n  color: #8a9ba7;\n}\n\n.detail-comment-composer-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.detail-comment-feed {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.detail-comment-feed-meta {\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n  margin: 4px 0 0;\n}\n\n.detail-comment-card {\n  display: grid;\n  grid-template-columns: 40px 1fr;\n  gap: 12px;\n  padding: 14px 16px;\n  background: #fff;\n  border: 1px solid #eaf0f0;\n  border-radius: 12px;\n  border-left: 3px solid #0d9b87;\n  transition: border-color 0.14s, box-shadow 0.14s;\n}\n\n.detail-comment-card:hover {\n  border-color: #dfe7e8;\n  box-shadow: 0 4px 16px rgba(6, 21, 36, 0.05);\n}\n\n.detail-comment-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-family: Lato, sans-serif;\n  font-weight: 700;\n  font-size: 15px;\n  color: #076b5c;\n  background: linear-gradient(145deg, #e1f4f0, #c8ebe4);\n  flex-shrink: 0;\n}\n\n.detail-comment-body {\n  min-width: 0;\n}\n\n.detail-comment-top {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.detail-comment-author {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 13.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n}\n\n.detail-comment-time {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: #8a9ba7;\n}\n\n.detail-comment-text {\n  margin: 0;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #0b1e2d;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.detail-comment-edit-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.detail-comment-empty {\n  padding: 28px 16px;\n  text-align: center;\n  color: #5f7484;\n  font-size: 13.5px;\n  background: #f7fafa;\n  border-radius: 12px;\n  border: 1px dashed #dfe7e8;\n}\n\n/* ——— RASCI matrix board (5-column) ——— */\n.rasci-board {\n  width: 100%;\n}\n\n.rasci-board-head {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n.rasci-board-kicker {\n  margin: 0 0 2px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: #0d9b87;\n}\n\n.rasci-board-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.rasci-columns {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 12px;\n  width: 100%;\n  align-items: stretch;\n}\n\n@media (max-width: 1100px) {\n  .rasci-columns {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 700px) {\n  .rasci-columns {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 420px) {\n  .rasci-columns {\n    grid-template-columns: 1fr;\n  }\n}\n\n.rasci-col {\n  display: flex;\n  flex-direction: column;\n  min-height: 168px;\n  background: #fff;\n  border: 1px solid #eaf0f0;\n  border-radius: 14px;\n  overflow: hidden;\n  border-top: 3px solid var(--rasci-accent, #0d9b87);\n  transition: box-shadow 0.16s, border-color 0.16s, transform 0.16s;\n}\n\n.rasci-col:hover {\n  border-color: #dfe7e8;\n  box-shadow: 0 8px 24px rgba(6, 21, 36, 0.06);\n  transform: translateY(-1px);\n}\n\n.rasci-col-head {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 14px 10px;\n  background: linear-gradient(180deg, #f7fafa 0%, #fff 100%);\n}\n\n.rasci-letter {\n  width: 32px;\n  height: 32px;\n  border-radius: 9px;\n  display: grid;\n  place-items: center;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  font-weight: 800;\n  letter-spacing: 0.02em;\n  flex-shrink: 0;\n}\n\n.rasci-col-label {\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 1px;\n}\n\n.rasci-col-name {\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  color: #0b1e2d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rasci-col-count {\n  font-size: 11.5px;\n  color: #8a9ba7;\n  font-weight: 500;\n}\n\n.rasci-col-body {\n  flex: 1;\n  padding: 4px 12px 14px;\n  display: flex;\n  flex-direction: column;\n}\n\n.rasci-people {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.rasci-person {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 7px 8px;\n  border-radius: 9px;\n  background: #f7fafa;\n  border: 1px solid transparent;\n  min-width: 0;\n}\n\n.rasci-person:hover {\n  border-color: #eaf0f0;\n  background: #fff;\n}\n\n.rasci-person-avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  display: grid;\n  place-items: center;\n  font-size: 11px;\n  font-weight: 800;\n  flex-shrink: 0;\n}\n\n.rasci-person-name {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #0b1e2d;\n  text-transform: capitalize;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rasci-unassigned {\n  margin-top: 4px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 10px;\n  border-radius: 9px;\n  border: 1px dashed #dfe7e8;\n  background: #fafcfc;\n  color: #8a9ba7;\n  font-size: 12.5px;\n  font-weight: 500;\n}\n\n.rasci-unassigned-dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: #c5d4d6;\n  flex-shrink: 0;\n}\n\n/* ——— Support document ——— */\n.support-panel {\n  width: 100%;\n}\n\n.support-file-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  padding: 16px 18px;\n  background: linear-gradient(165deg, #ffffff 0%, #f7fafa 100%);\n  border: 1px solid #dfe7e8;\n  border-radius: 14px;\n  border-left: 3px solid #0d9b87;\n}\n\n.support-file-main {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n  flex: 1;\n}\n\n.support-file-ico {\n  width: 44px;\n  height: 44px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  background: #e1f4f0;\n  color: #076b5c;\n  flex-shrink: 0;\n}\n\n.support-file-meta {\n  min-width: 0;\n}\n\n.support-file-name {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 14.5px;\n  font-weight: 700;\n  color: #00146d;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.support-file-hint {\n  margin: 3px 0 0;\n  font-size: 12.5px;\n  color: #8a9ba7;\n}\n\n.support-file-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.support-dropzone {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 8px;\n  padding: 36px 24px;\n  border-radius: 14px;\n  border: 1.5px dashed #c5d4d6;\n  background: #f7fafa;\n  transition: border-color 0.14s, background 0.14s;\n}\n\n.support-dropzone.is-drag {\n  border-color: #0d9b87;\n  background: #e1f4f0;\n}\n\n.support-drop-ico {\n  width: 56px;\n  height: 56px;\n  border-radius: 14px;\n  display: grid;\n  place-items: center;\n  background: #fff;\n  color: #0d9b87;\n  border: 1px solid #dfe7e8;\n  margin-bottom: 4px;\n}\n\n.support-drop-title {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 15px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.support-drop-msg {\n  margin: 0 0 10px;\n  max-width: 420px;\n  font-size: 13.5px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.support-drop-error {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  color: #d14a3e;\n}\n\n/* ——— Shared detail modal shell ——— */\n.incyia-modal-paper {\n  border-radius: 14px !important;\n  overflow: hidden;\n  box-shadow: 0 30px 80px -24px rgba(0, 0, 0, 0.45) !important;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-modal-head {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 22px 0;\n}\n\n.incyia-modal-head h3 {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #00146d;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-modal-head p {\n  margin: 4px 0 0;\n  font-size: 12.5px;\n  color: #5f7484;\n  line-height: 1.4;\n}\n\n.incyia-combo {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px 22px;\n  margin-top: 12px;\n}\n\n.incyia-combo-item {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  min-width: 0;\n}\n\n.incyia-combo-k {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: #8a9ba7;\n}\n\n.incyia-combo-v {\n  font-size: 14px;\n  font-weight: 600;\n  color: #0b1e2d;\n  line-height: 1.35;\n}\n\n.incyia-combo-banner {\n  margin: 0 0 16px;\n  padding: 14px 16px;\n  border: 1px solid #d7e4ea;\n  border-left: 3px solid #0d9b87;\n  border-radius: 10px;\n  background: #f4fbf9;\n}\n\n.incyia-combo-banner h3 {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #00146d;\n}\n\n.incyia-combo-banner > p {\n  margin: 4px 0 0;\n  font-size: 14px;\n  line-height: 1.45;\n  color: #5f7484;\n}\n\n.incyia-fix-dialog.incyia-modal-paper {\n  max-width: 560px;\n}\n\n.incyia-fix-dialog .incyia-modal-head {\n  padding: 24px 24px 0;\n}\n\n.incyia-fix-dialog .incyia-modal-head h3 {\n  font-size: 20px;\n  line-height: 1.3;\n}\n\n.incyia-fix-dialog .incyia-modal-head p {\n  margin-top: 8px;\n  font-size: 16px;\n  line-height: 1.5;\n  color: #3d5160;\n}\n\n.incyia-fix-dialog .incyia-modal-body {\n  padding: 16px 24px 8px;\n}\n\n.incyia-fix-dialog .incyia-combo {\n  flex-direction: column;\n  gap: 12px;\n  margin: 0;\n  padding: 14px 16px;\n  border-radius: 10px;\n  background: #f4fbf9;\n  border: 1px solid #d7e4ea;\n}\n\n.incyia-fix-dialog .incyia-combo-k {\n  font-size: 13px;\n  letter-spacing: 0.04em;\n}\n\n.incyia-fix-dialog .incyia-combo-v {\n  font-size: 16px;\n  line-height: 1.4;\n}\n\n.incyia-fix-dialog .incyia-modal-foot {\n  padding: 16px 24px;\n}\n\n.incyia-fix-dialog .detail-btn {\n  height: 40px;\n  padding: 0 16px;\n  font-size: 16px;\n}\n\n.incyia-modal-x {\n  margin-left: auto;\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  display: grid;\n  place-items: center;\n  color: #8a9ba7;\n  background: none;\n  border: none;\n  cursor: pointer;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.incyia-modal-x:hover {\n  background: #eaf0f0;\n  color: #0b1e2d;\n}\n\n.incyia-status-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 0;\n  padding: 12px 18px;\n}\n\n.incyia-modal-body {\n  padding: 18px 22px;\n}\n\n.incyia-modal-foot {\n  padding: 14px 22px;\n  background: #f7fafa;\n  border-top: 1px solid #dfe7e8;\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.incyia-confirm-details {\n  margin: 0;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: #f7f9fd;\n  border: 1px solid #eaeff7;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n}\n\n.incyia-confirm-detail {\n  display: grid;\n  grid-template-columns: 100px 1fr;\n  gap: 10px;\n  align-items: start;\n}\n\n.incyia-confirm-detail dt {\n  margin: 0;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #8b99b4;\n  padding-top: 2px;\n}\n\n.incyia-confirm-detail dd {\n  margin: 0;\n  font-size: 13.5px;\n  font-weight: 600;\n  color: #0b1e2d;\n  line-height: 1.35;\n  word-break: break-word;\n}\n\n.detail-icon-btn--danger {\n  color: #8a9ba7;\n}\n\n.detail-icon-btn--danger:hover {\n  background: #fae6e3;\n  color: #d14a3e;\n}\n\n.incyia-modal-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 12px;\n  display: grid;\n  place-items: center;\n  flex-shrink: 0;\n  background: #e2f7f2;\n  color: #076b5c;\n}\n\n.incyia-modal-icon--warn {\n  background: #fff4e5;\n  color: #b86e00;\n}\n\n.incyia-modal-icon--danger {\n  background: #fae6e3;\n  color: #d14a3e;\n}\n\n.incyia-modal-countdown {\n  margin: 4px 0 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  padding: 16px;\n  border-radius: 12px;\n  background: #f7f9fd;\n  border: 1px solid #eaeff7;\n}\n\n.incyia-modal-countdown-value {\n  font-size: 28px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  color: #00146d;\n  font-variant-numeric: tabular-nums;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-modal-countdown-label {\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #8b99b4;\n}\n\n.detail-btn--danger {\n  background: #d14a3e !important;\n  color: #fff !important;\n  box-shadow: 0 1px 2px rgba(209, 74, 62, 0.35);\n}\n\n.detail-btn--danger:hover:not(:disabled) {\n  background: #b83f35 !important;\n}\n\n/* RASCI assign / edit modal */\n.rasci-edit-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.rasci-edit-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 220px;\n  padding: 24px;\n  text-align: center;\n}\n\n.rasci-edit-loading p {\n  margin: 0;\n  font-size: 13.5px;\n  color: #5f7484;\n}\n\n.rasci-edit-spinner {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2.5px solid #e1f4f0;\n  border-top-color: #0d9b87;\n  animation: rasci-spin 0.7s linear infinite;\n}\n\n@keyframes rasci-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.rasci-edit-row {\n  display: grid;\n  grid-template-columns: 132px minmax(0, 1fr);\n  gap: 12px;\n  align-items: center;\n  padding: 12px;\n  background: #f7fafa;\n  border: 1px solid #eaf0f0;\n  border-radius: 12px;\n}\n\n@media (max-width: 560px) {\n  .rasci-edit-row {\n    grid-template-columns: 1fr;\n    align-items: start;\n  }\n}\n\n.rasci-edit-role {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 10px;\n  border-radius: 8px;\n  font-size: 12.5px;\n  font-weight: 700;\n  width: fit-content;\n  max-width: 100%;\n}\n\n.rasci-edit-field {\n  min-width: 0;\n  width: 100%;\n}\n\n.rasci-edit-select {\n  width: 100%;\n}\n\n.rasci-edit-select .MuiOutlinedInput-root {\n  background: #fff;\n  border-radius: 8px;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  min-height: 40px;\n}\n\n.rasci-edit-select .MuiSelect-select {\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.rasci-edit-select .MuiOutlinedInput-notchedOutline {\n  border-color: #dfe7e8;\n}\n\n.rasci-edit-select .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline {\n  border-color: #8a9ba7;\n}\n\n.rasci-edit-select .Mui-focused .MuiOutlinedInput-notchedOutline {\n  border-color: #0d9b87 !important;\n  border-width: 1.5px !important;\n}\n\n.rasci-select-placeholder {\n  color: #8a9ba7;\n  font-size: 13px;\n  font-family: Lato, sans-serif;\n}\n\n.rasci-edit-chip {\n  border-radius: 999px !important;\n  background: #e1f4f0 !important;\n  color: #076b5c !important;\n  font-weight: 600 !important;\n  font-size: 12px !important;\n  height: 26px !important;\n  max-width: 160px;\n}\n\n.rasci-edit-chip .MuiChip-label {\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.rasci-select-menu {\n  border-radius: 10px !important;\n  border: 1px solid #dfe7e8 !important;\n  box-shadow: 0 16px 40px rgba(6, 21, 36, 0.14) !important;\n  overflow: hidden;\n}\n\n.rasci-select-menu-list {\n  padding: 6px !important;\n  font-family: Lato, sans-serif;\n}\n\n.rasci-select-option {\n  display: flex !important;\n  align-items: center !important;\n  justify-content: space-between !important;\n  gap: 10px !important;\n  margin: 2px 0 !important;\n  padding: 8px 10px !important;\n  border-radius: 8px !important;\n  font-family: Lato, sans-serif !important;\n  font-size: 13px !important;\n  color: #0b1e2d !important;\n  min-width: 0 !important;\n}\n\n.rasci-select-option:hover,\n.rasci-select-option.Mui-focused {\n  background: #f7fafa !important;\n}\n\n.rasci-select-option.Mui-selected {\n  background: #e1f4f0 !important;\n  color: #076b5c !important;\n}\n\n.rasci-select-option.Mui-selected:hover {\n  background: #d2efe8 !important;\n}\n\n.rasci-select-option-name {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-weight: 600;\n}\n\n.rasci-edit-menu-role {\n  flex-shrink: 0;\n  background: #eaf0f0;\n  color: #5f7484;\n  padding: 2px 8px;\n  border-radius: 6px;\n  font-size: 10.5px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  max-width: 72px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Document viewer */\n.doc-viewer-shell {\n  display: flex;\n  flex-direction: column;\n  height: min(78vh, 720px);\n  background: #0b1e2d;\n}\n\n.doc-viewer-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  flex-wrap: wrap;\n  padding: 12px 16px;\n  background: linear-gradient(180deg, #0f2740 0%, #0b1e2d 100%);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.doc-viewer-file {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-width: 0;\n}\n\n.doc-viewer-file-ico {\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: grid;\n  place-items: center;\n  background: rgba(13, 155, 135, 0.18);\n  color: #5ee0cb;\n  flex-shrink: 0;\n}\n\n.doc-viewer-file-name {\n  margin: 0;\n  font-family: Lato, sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  color: #fff;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: min(420px, 55vw);\n}\n\n.doc-viewer-file-sub {\n  margin: 2px 0 0;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.55);\n}\n\n.doc-viewer-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.doc-viewer-frame-wrap {\n  flex: 1;\n  min-height: 0;\n  background: #525659;\n  position: relative;\n}\n\n.doc-viewer-frame-wrap iframe {\n  width: 100%;\n  height: 100%;\n  border: none;\n  display: block;\n}\n\n.doc-viewer-fallback {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 32px;\n  text-align: center;\n  background: #f7fafa;\n  color: #5f7484;\n}\n\n.doc-viewer-fallback p {\n  margin: 0;\n  max-width: 360px;\n  font-size: 13.5px;\n  line-height: 1.45;\n}\n\n.doc-viewer-actions .detail-btn--ghost {\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.doc-viewer-actions .detail-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.14);\n  border-color: rgba(255, 255, 255, 0.28);\n}\n\n.doc-viewer-actions .detail-btn:not(.detail-btn--ghost) {\n  background: #0d9b87;\n}\n\n.doc-viewer-actions .detail-btn:not(.detail-btn--ghost):hover {\n  background: #076b5c;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
